import React, { Suspense, lazy, useState } from 'react'

import cn from 'classnames'
import { useSearchParams } from 'react-router-dom'
import styles from './style.module.css'
import Preloader from './Preloader'
import Header from './Header'
import PageLayout from '~components/PageLayout'
import { QueryParams } from '~constants/routes'
import { View } from '~constants/buy'

const BuyWidget = lazy(() => import('~components/BuyWidget'))

function BuyPage() {
    const [view, setView] = useState<View>(View.Buy)
    const [searchParams] = useSearchParams()
    const toCurrency = searchParams.get(QueryParams.toCurrency) || ''
    const fromCurrency = searchParams.get(QueryParams.fromCurrency) || ''
    const amount = searchParams.get(QueryParams.amount) || ''

    const onViewChange = (view: View) => {
        setView(view)
    }

    return (
        <Suspense fallback={<Preloader />}>
            <PageLayout contentWidth="m" header={<Header view={view} />} noBorder={view === View.TxInfo}>
                <div
                    data-pointer="buy_widget_page"
                    className={cn(styles.wrap, view === View.TxInfo && styles.noMargin)}
                >
                    <BuyWidget
                        initialValues={{
                            toCurrencyCode: toCurrency,
                            fromCurrencyCode: fromCurrency,
                            amount,
                        }}
                        onViewChange={onViewChange}
                    />
                </div>
            </PageLayout>
        </Suspense>
    )
}

export default BuyPage
